const pricingIframeMessageSources = new Map();

export function resolvePricingIframeOrigin(url = "") {
	const rawUrl = typeof url === "string" ? url.trim() : "";
	if (!rawUrl) {
		return "";
	}

	try {
		const baseUrl = typeof window !== "undefined" && window.location && window.location.href
			? window.location.href
			: "https://localhost/";
		const origin = new URL(rawUrl, baseUrl).origin;
		return origin && origin !== "null" ? origin : "";
	} catch (_err) {
		return "";
	}
}

function getIframeWindow(iframe = null) {
	return iframe && iframe.contentWindow ? iframe.contentWindow : iframe;
}

export function isMessageFromPricingIframe(event, iframe, url = "") {
	const source = getIframeWindow(iframe);
	const origin = resolvePricingIframeOrigin(url);
	return Boolean(
		event
		&& source
		&& origin
		&& event.source === source
		&& event.origin === origin
	);
}

export function registerPricingIframeMessageSource(owner, iframe, url = "") {
	if (!owner) {
		return false;
	}

	const source = getIframeWindow(iframe);
	const origin = resolvePricingIframeOrigin(url);
	if (!source || !origin) {
		pricingIframeMessageSources.delete(owner);
		return false;
	}

	pricingIframeMessageSources.set(owner, { source, origin });
	return true;
}

export function unregisterPricingIframeMessageSource(owner) {
	if (owner) {
		pricingIframeMessageSources.delete(owner);
	}
}

export function isRegisteredPricingIframeMessage(event) {
	if (!event || !event.source || !event.origin) {
		return false;
	}

	for (const entry of pricingIframeMessageSources.values()) {
		if (entry.source === event.source && entry.origin === event.origin) {
			return true;
		}
	}

	return false;
}
